export const GA_ID = 'UA-75126614-1'
